import React, { Component, createRef } from "react";
import { Modal, Row, Col, Tabs, Tab, Container, Card, ProgressBar, Badge, Table, Button, Image } from 'react-bootstrap';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import './_studentPerformanceReport.scss';

class SubjectWiseReportCardModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPDF: false,
        };
        this.reportRef1 = createRef();
    }

    downloadPDF = () => {
        this.setState({ loadingPDF: true }, () => {
            setTimeout(() => {
                this.generatePDF();
            }, 100); // allow UI to render loader
        });
    };

    generatePDF = async () => {
        try {

            const element = this.reportRef1.current


            const canvas = await html2canvas(element, {
                scale: 1.5,
                useCORS: true,
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");

            const imgWidth = 210;
            const pageHeight = 295;

            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const finalHeight = Math.min(imgHeight, pageHeight);

            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, finalHeight);
            pdf.save("ReportCard.pdf");

        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loadingPDF: false });
        }
    };

    getAcademicYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();

        if (month >= 3) {
            // April or later
            return `${year}–${String(year + 1).slice(2)}`;
        } else {
            // Jan–March
            return `${year - 1}–${String(year).slice(2)}`;
        }
    };

    render() {
        let branchvalue = "";
        let classvalue = "";
        let sectionvalue = "";
        let examValue = "";

        branchvalue = this.props.globalData.globalBranches.find((a) => a.id === this.props.studentData?.branch_id);
        classvalue = this.props.globalData.classes.find((a) => a.id === this.props.studentData?.class_id);
        sectionvalue = this.props.globalData.globalSections.find((a) => a.id === this.props.studentData?.section_id);
        examValue = this.props.globalData.exams.find((a) => a.id === this.props.studentData?.exam_id);


        return (
            <Modal {...this.props} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">View Pdf</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{
                    width: '100%',
                    height: '600px',
                    overflow: 'auto',
                }}>
                    <Row>
                        <Col sm={12}>
                            <div className="text-end d-flex justify-content-end mb-1">
                                <Button onClick={this.downloadPDF} disabled={
                                    this.state.loadingPDF
                                }
                                    size="small">
                                    {this.state.loadingPDF ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Generating...
                                        </>
                                    ) : (
                                        <><i className="fa fa-download"></i>&nbsp;Download PDF</>
                                    )}
                                </Button>
                            </div>


                            <div ref={this.reportRef1}>
                                <Card className="p-3 shadow-sm">
                                    <div
                                        style={{
                                            background: "rgba(255,255,255,0.9)",
                                            padding: "20px",
                                            borderRadius: "10px",
                                        }}
                                    >

                                        {/* 🔷 Header */}
                                        <div className="report-header mb-4">

                                            {/* 🔷 Top Row: Logo + School Name */}
                                            <div className="d-flex align-items-center justify-content-between mb-2">


                                                {/* Center: School Name */}
                                                <div className="text-center flex-grow-1">
                                                    <h4 className="fw-bold mb-0">  <div>
                                                        {this.props.logo ? (
                                                            <Image
                                                                src={`https://support.rizee.in/files/${this.props.logo}`}
                                                                height="50"
                                                                style={{ width: "auto" }}
                                                            />
                                                        ) : null}
                                                    </div>{this.props.orgname}</h4>
                                                    <small className="text-muted">
                                                        Academic Year {this.getAcademicYear()} · Class {classvalue.class}
                                                    </small>
                                                </div>

                                                {/* Right: Empty for balance */}
                                                <div style={{ width: "50px" }}></div>

                                            </div>

                                            {/* 🔷 Report Title */}
                                            <div className="text-center mt-2">
                                                <h5 className="fw-bold text-primary">
                                                    Individual Student Report Card
                                                </h5>
                                            </div>
                                        </div>

                                        {/* 🔷 Student Section */}
                                        <Row className="align-items-center">

                                            {/* 👤 Profile Image */}
                                            <Col md={2} className="text-center mb-3 mb-md-0">
                                                {this.props.studentData?.profile_pic ? (
                                                    <Image
                                                        src={`http://neetjeeguru.com/files/${this.props.studentData?.profile_pic}`}
                                                        width="90"
                                                        height="90"
                                                        roundedCircle
                                                        className="shadow"
                                                        alt="profile-img"
                                                    />
                                                ) : (
                                                    <Image
                                                        src={require('../../../../images/businessman.png')}
                                                        width="90"
                                                        height="90"
                                                        roundedCircle
                                                        className="shadow"
                                                        alt="profile-img"
                                                    />
                                                )}
                                            </Col>

                                            {/* 👤 Student Details */}
                                            <Col md={5}>
                                                <h5 className="fw-bold mb-1">
                                                    {this.props.studentData?.student_name || "N/A"}
                                                </h5>

                                                <Badge bg="primary" className="mb-2">
                                                    <span className="text-success">Class</span> {classvalue.class} - <span className="text-success">Section</span> {sectionvalue.section_name}
                                                </Badge>

                                                <p className="mb-1">
                                                    <strong>Exam:</strong> {examValue.exam}
                                                </p>
                                            </Col>

                                            {/* 🏫 School / Contact Info */}
                                            <Col md={5}>
                                                <p className="mb-1">
                                                    <strong>Branch:</strong> {branchvalue?.branch_name}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Contact:</strong> {this.props.studentData?.contact_no}
                                                </p>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Marks Table */}
                                    <h6 className="mb-2">Subject-wise Performance</h6>
                                    <Table className="custom-table" responsive>
                                        <thead className=" text-start">
                                            <tr>
                                                <th>📘 Subject</th>
                                                <th>🏆 Best Score</th>
                                                <th>📉 Lowest Score</th>
                                                <th>📊 Section Avg</th>
                                                <th>🏫 Branch Avg</th>
                                                <th>📈 Performance</th>
                                            </tr>
                                        </thead>

                                        <tbody className="text-start">
                                            {this.props.stateData?.map((item, index) => {

                                                // 🔥 Performance Logic
                                                let performance = "Average";
                                                let color = "warning";

                                                if (item.section_avg >= 70) {
                                                    performance = "Excellent";
                                                    color = "success";
                                                } else if (item.section_avg >= 50) {
                                                    performance = "Good";
                                                    color = "primary";
                                                } else if (item.section_avg >= 35) {
                                                    performance = "Average";
                                                    color = "warning";
                                                } else {
                                                    performance = "Poor";
                                                    color = "danger";
                                                }

                                                return (
                                                    <tr key={index}>
                                                        {/* Subject */}
                                                        <td className="fw-semibold text-start">{item.subject}</td>

                                                        {/* Best Score */}
                                                        <td className="text-success fw-bold">
                                                            {item.best_score}
                                                        </td>

                                                        {/* Lowest Score */}
                                                        <td className="text-danger fw-bold">
                                                            {item.lowest_score}
                                                        </td>

                                                        {/* Section Avg */}
                                                        <td>
                                                            {item.section_avg?.toFixed(2)}
                                                        </td>

                                                        {/* Branch Avg */}
                                                        <td>
                                                            {item.branch_avg?.toFixed(2)}
                                                        </td>

                                                        {/* Performance */}
                                                        <td>
                                                            <Badge bg={color} pill>
                                                                {performance}
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>

                                        <h6>Teacher's Remarks</h6>
                                    {
                                        this.props.stateData?.map((item, index) => {

                                            let performance = "Average";
                                            let color = "warning";

                                            if (item.section_avg >= 70) {
                                                performance = "Excellent";
                                                color = "success";
                                            } else if (item.section_avg >= 50) {
                                                performance = "Good";
                                                color = "primary";
                                            } else if (item.section_avg >= 35) {
                                                performance = "Average";
                                                color = "warning";
                                            } else {
                                                performance = "Poor";
                                                color = "danger";
                                            }

                                            return (
                                                <tr key={index}>
                                                    {/* Subject */}
                                                    <td className="fw-semibold">📘 {item.subject}</td>

                                                    {/* Performance */}
                                                    <td>
                                                        <Badge bg={color}>{performance}</Badge>
                                                    </td>

                                                    {/* Remarks */}
                                                    <td>
                                                        <ul className="mb-0 ps-3">
                                                            {item.section_avg >= 70 && (
                                                                <li className="text-success">Excellent performance</li>
                                                            )}
                                                            {item.section_avg >= 50 && item.section_avg < 70 && (
                                                                <li className="text-primary">Good understanding of concepts</li>
                                                            )}
                                                            {item.section_avg >= 35 && item.section_avg < 50 && (
                                                                <li className="text-warning">Needs more practice</li>
                                                            )}
                                                            {item.section_avg < 35 && (
                                                                <li className="text-danger">Needs serious improvement</li>
                                                            )}
                                                        </ul>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }

                                    {/* Footer */}
                                    <Row className="mt-4 text-center">
                                        <Col>
                                            <hr />
                                            <small>Class Teacher</small>
                                        </Col>
                                        {/* <Col>
                                            <Badge bg="success">PROMOTED TO CLASS XI</Badge>
                                        </Col> */}
                                        <Col>
                                            <hr />
                                            <small>Principal</small>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}
export default SubjectWiseReportCardModal;